<!--企业高质量发展培育-->
<template>
  <div class="development-container">
    <header-index/>
    <div class="development-content">
      <div class="development-breadcrumb">
        <span>您当前位置:</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
              :to="{ path: '/cloudPlatform/platform?city=2&cityName='+childNode.name+'&cityCode='+childNode.cityCode+'&parentCityCode='+childNode.parentCityCode+'&pName='+childNode.name+'企业数字化服务云平台&parName=渝企服务云' }">
            服务平台
          </el-breadcrumb-item>
          <el-breadcrumb-item
              :to="{ path: '/cultivation/index?city=2&cityName='+childNode.name+'&cityCode='+childNode.cityCode+'&parentCityCode='+childNode.parentCityCode+'&pName='+childNode.name+'企业数字化服务云平台&parName=渝企服务云' }">
            企业培育
          </el-breadcrumb-item>
          <el-breadcrumb-item>企业高质量发展培育</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="development-info">
        <p class="development-title">民营企业高质量发展培育俱乐部会员申请表</p>
        <p class="development-tips">
          民营企业高质量发展培育俱乐部属于中心内设机构，主要面向全市民营企业提供融资、项目申报、知识产权、科技赋能等辅导培育工作，实行会员制管理，企业自愿申请，免费加入，经中心审核批准后享受会员资格，俱乐部仅对会员提供专业服务，按照会员享受的权益以及专业服务内容收费。</p>
        <el-form :model="developmentForm" :rules="rules" label-position="right" ref="developmentForm0"
                 label-width="160px" class="developmentForm">
          <el-form-item label="企业名称:" prop="businessName">
            <el-input v-model="developmentForm.businessName" style="width: 100%"/>
          </el-form-item>
          <el-form :inline="true" class="demo-form-inline" :rules="rules" :model="developmentForm" label-width="160px" ref="developmentForm1"
                   label-position="right">
            <el-form-item label="法定代表人:" prop="legalPerson">
              <el-input v-model="developmentForm.legalPerson" style="width: 16vw"/>
            </el-form-item>
            <el-form-item label="联系电话:" prop="legalPhone">
              <el-input v-model="developmentForm.legalPhone" style="width: 17.04vw"/>
            </el-form-item>
          </el-form>
          <el-form :inline="true" class="demo-form-inline" :rules="rules" :model="developmentForm" label-width="160px" ref="developmentForm2"
                   label-position="right">
            <el-form-item label="联系人:" prop="contacts">
              <el-input v-model="developmentForm.contacts" style="width: 16vw"/>
            </el-form-item>
            <el-form-item label="联系电话:" prop="phone">
              <el-input v-model="developmentForm.phone" style="width: 17.04vw"/>
            </el-form-item>
          </el-form>
          <el-form-item label="所属行业:" prop="industry" class="industry-select">
            <el-select v-model="developmentForm.industry" placeholder="请选择" clearable @change="changeIndustry"
                       style="width: 16vw;margin-right: 170px;">
              <el-option v-for="item in industryList" :label="item.categoryName" :value="item.categoryName"/>
            </el-select>
            <el-select v-model="developmentForm.subset" placeholder="请选择" clearable
                       :disabled="developmentForm.industry!='' ? false : true" style="width: 17.04vw">
              <el-option v-for="item2 in subsetList" :label="item2.categoryName" :value="item2.categoryName"/>
            </el-select>
          </el-form-item>
          <el-form :inline="true" class="demo-form-inline" :rules="rules" :model="developmentForm" label-width="160px" ref="developmentForm3"
                   label-position="right">
            <el-form-item label="注册时间:" prop="time">
              <el-date-picker v-model="developmentForm.time" value-format="yyyy-MM-dd" style="width: 16vw" placeholder="请选择" type="date"/>
            </el-form-item>
            <el-form-item label="注册资金(万元):" prop="money">
              <el-input v-model="developmentForm.money" style="width: 17.04vw"/>
            </el-form-item>
          </el-form>
          <el-form-item label="注册地址:" prop="city" class="industry-select">
            <el-select v-model="developmentForm.province" placeholder="请选择" clearable @change="changeProvincial"
                       :style="developmentForm.province!=110000 && developmentForm.province!=120000 && developmentForm.province!=500000 && developmentForm.province!=310000 ? 'width: 12vw;margin-right: 56px;' : 'width: 16vw;margin-right: 160px;'">
              <el-option v-for="item in provincialCodeItem" :label="item.name" :value="item.id"/>
            </el-select>
            <el-select v-model="developmentForm.city" placeholder="请选择" clearable @change="changeCity"
                       :disabled="developmentForm.province!='' ? false : true"
                       :style="developmentForm.province!=110000 && developmentForm.province!=120000 && developmentForm.province!=500000 && developmentForm.province!=310000 ? 'width: 12vw;margin-right: 56px;' : 'width: 17.04vw;'">
              <el-option v-for="item1 in cityItem" :label="item1.name" :value="item1.id"/>
            </el-select>
            <el-select v-model="developmentForm.district" placeholder="请选择" clearable @change="changeDistrict"
                       :disabled="developmentForm.city!='' ? false : true"
                       :style="developmentForm.province!=110000 && developmentForm.province!=120000 && developmentForm.province!=500000 && developmentForm.province!=310000 ? 'width: 12vw;' : 'display:none;'">
              <el-option v-for="item2 in districtItem" :label="item2.name" :value="item2.id"/>
            </el-select>
          </el-form-item>
          <el-form :inline="true" class="demo-form-inline" :rules="rules" :model="developmentForm" label-width="160px" ref="developmentForm4"
                   label-position="right">
            <el-form-item label="职工人数:" prop="employees">
              <el-input v-model="developmentForm.employees" style="width: 16vw"/>
            </el-form-item>
            <el-form-item label="电子邮箱:" prop="email">
              <el-input v-model="developmentForm.email" style="width: 17.04vw"/>
            </el-form-item>
          </el-form>
          <el-form-item label="主营业务范围:" prop="business_scope">
            <el-input v-model="developmentForm.business_scope" style="width: 100%" maxlength="1000" type="textarea"
                      :autosize="{ minRows: 3, maxRows: 12}"/>
          </el-form-item>
          <el-form-item label="企业简介:">
            <el-input v-model="developmentForm.introduction" style="width: 100%" maxlength="1000" type="textarea"
                      :autosize="{ minRows: 3, maxRows: 12}"/>
          </el-form-item>
          <el-form-item label="取得的荣誉和资质证书:">
            <el-input v-model="developmentForm.certificate" style="width: 100%"/>
          </el-form-item>
          <el-form-item>
            <el-upload action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg" :limit="9"
                       ref="upload"
                       list-type="picture-card" :file-list="fileList" :on-exceed="handleExceed" :multiple="true"
                       :on-success="successUpload" accept=".png,.jpeg,.jpg,.pdf" :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemove">
              <el-link type="primary" :underline="false" icon="el-icon-plus">上传附件</el-link>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <el-dialog :visible.sync="dialogVisible2" title="图片预览" width="550px">
      <el-image :src="dialogImageUrl" style="width: 500px;height: auto"/>
    </el-dialog>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {isMobile, isMoney,isEmail,isPositiveInteger} from "@/common/tools";
import {pyfdAppOperatingIndustry,pyfdAppSaveHighQualitySystem} from '@/api/pySystemApi'
import provincialCode from '@/static/marketCityList.json'

export default {
  name: "development_cultivation",
  components: {headerIndex, home_footer, Hang},
  data() {
    const checkPhone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入联系电话'));
      } else if (!isMobile(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    }
    const checkIndustry = (rule, value, callback) => {
      if (this.developmentForm.industry != '') {
        if (this.developmentForm.subset != '') {
          callback();
        } else {
          callback(new Error('请选择二级所属行业'));
        }
      } else {
        callback(new Error('请选择一级所属行业'));
      }
    }
    const checkMoney = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('注册资金不能为空'));
      } else if (!isMoney(value)) {
        callback(new Error('请输入合法的金额数字，最多两位小数'));
      } else {
        callback();
      }
    }
    const checkCity = (rule, value, callback) => {
      if (this.developmentForm.province != '') {
        if (this.developmentForm.city != '') {
          if (this.developmentForm.province != 110000 && this.developmentForm.province != 120000 && this.developmentForm.province != 500000 && this.developmentForm.province != 310000) {
            if (this.developmentForm.district != '') {
              callback();
            } else {
              callback(new Error('请选择具体区县'));
            }
          } else {
            callback();
          }
        } else {
          callback(new Error('请选择二级注册地址'));
        }
      } else {
        callback(new Error('请选择一级注册地址'));
      }
    }
    const PositiveInteger = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('职工人数不能为空'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入大于0的正整数'));
      } else {
        callback();
      }
    }
    const checkEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('电子邮箱不能为空'));
      } else if (!isEmail(value)) {
        callback(new Error('请输入合法的邮箱地址'));
      } else {
        callback();
      }
    }
    return {
      min_height: document.documentElement.clientHeight - 315,
      childNode: {},
      cid: 0,
      pName: '',
      developmentForm: {
        businessName: '',
        legalPerson: '',
        legalPhone: '',
        contacts: '',
        phone: '',
        industry: '',
        subset: '',
        time: '',
        money: '',
        province: '',
        city: '',
        district: '',
        provinceName: '',
        cityName: '',
        districtName: '',
        employees:'',
        email:'',
        business_scope:'',
        introduction:'',
        certificate:'',
        img: [],
      },
      industryList: [],
      subsetList: [],
      provincialCodeItem: provincialCode,
      cityItem: [],
      districtItem: [],
      rules: {
        businessName: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
          {min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur'}
        ],
        legalPerson: [
          {required: true, message: '请输入法定代表人', trigger: 'blur'},
          {min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur'}
        ],
        contacts: [
          {required: true, message: '请输入联系人', trigger: 'blur'},
          {min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur'}
        ],
        legalPhone: [
          {required: true, validator: checkPhone, trigger: 'blur'}
        ],
        phone: [
          {required: true, validator: checkPhone, trigger: 'blur'}
        ],
        industry: [
          {required: true, validator: checkIndustry, trigger: 'change'}
        ],
        time: [
          {required: true, message: '请选择注册时间', trigger: 'change'}
        ],
        money: [
          {required: true, validator: checkMoney, trigger: 'blur'}
        ],
        city: [
          {required: true, validator: checkCity, trigger: 'change'}
        ],
        employees:[
          {required: true, validator: PositiveInteger, trigger: 'blur'}
        ],
        email:[
          {required: true, validator: checkEmail, trigger: 'blur'}
        ],
        business_scope:[
          {required: true, message: '请输入主营业务范围', trigger: 'blur'},
          {min: 0, max: 100, message: '长度在 1 到 1000 个字符', trigger: 'blur'}
        ],
      },
      dialogImageUrl: '',
      dialogVisible2: false,
      fileList: [],
    }
  },
  methods: {
    /*获取所属行业类型*/
    getPyfdAppOperatingIndustry() {
      pyfdAppOperatingIndustry().then(res => {
        if (res.code == 200) {
          this.industryList = res.content.list;
        }
      })
    },
    /*监听所属行业修改*/
    changeIndustry(value) {
      for (let list of this.industryList) {
        if (list.categoryName == value) {
          this.subsetList = list.smesIndustryAppList;
          this.developmentForm.subset = '';
        }
      }
    },
    /*监听注册地址修改*/
    changeProvincial(value) {
      for (let list of this.provincialCodeItem) {
        if (list.id == value) {
          this.developmentForm.city = '';
          this.developmentForm.districtName = '';
          this.developmentForm.cityName = '';
          if (value != 110000 && value != 120000 && value != 500000 && value != 310000) {
            this.developmentForm.provinceName = list.name;
            this.cityItem = list.children;
          } else {
            this.developmentForm.provinceName = list.children[0].name;
            this.cityItem = list.children[0].children;
          }
        }
      }
    },
    /*监听注册城市修改*/
    changeCity(value) {
      for (let list of this.cityItem) {
        if (list.id == value) {
          this.districtItem = list.children;
          this.developmentForm.district = '';
          this.developmentForm.districtName = '';
          this.developmentForm.cityName = list.name;
        }
      }
    },
    /*监听具体区县修改*/
    changeDistrict() {
      for (let list of this.districtItem) {
        if (list.id == value) {
          this.developmentForm.districtName = list.name;
        }
      }
    },
    /*图片在线预览*/
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },
    /*检索上传数量，限制上传9张*/
    handleExceed(files, fileList) {
      this.$message.error(`已超过上传上限！`);
    },
    /*上传图片成功处理*/
    successUpload(response, file, fileList) {
      this.developmentForm.img.push(response.imgPath);
    },
    /*图片删除*/
    handleRemove(file, fileList) {
      for (let i in this.developmentForm.img) {
        if (this.developmentForm.img[i] == file.response.imgPath) {
          this.developmentForm.img.splice(i, 1)
        }
      }
    },
    /*提交*/
    submitForm(){
      let can = 0;
      let formData={};
      for (let a = 0; a < 5; a++) {
        this.$refs['developmentForm'+a].validate((valid) => {
          if (valid) {} else {
            can++;
            return false;
          }
        });
      }
      if (can==0){
        formData={
          companyName:this.developmentForm.businessName,
          legalPerson:this.developmentForm.legalPerson,
          corporatePhone:this.developmentForm.legalPhone,
          contactPerson:this.developmentForm.contacts,
          contactPersonPhone:this.developmentForm.phone,
          operatingIndustry:this.developmentForm.industry+'-'+this.developmentForm.subset,
          registrationTime:this.developmentForm.time,
          registeredCapital:this.developmentForm.money,
          unitLocation:this.developmentForm.provinceName+this.developmentForm.cityName+this.developmentForm.districtName,
          enterpriseSize:this.developmentForm.employees,
          email:this.developmentForm.email,
          mainBusiness:this.developmentForm.business_scope,
          introduction:this.developmentForm.introduction,
          certifications:this.developmentForm.certificate,
          businessLicenseImgList:this.developmentForm.img,
          xmsbUserId:this.cid!=0 ? this.cid : ''
        }
        pyfdAppSaveHighQualitySystem({highQualitySystem:JSON.stringify(formData),request:'form'}).then(res=>{
          if (res.code==200){
            this.$message.success(res.msg);
            this.$router.replace({
              path: '/cultivation/index',
              query: {
                city: this.childNode.cityCode,
                cityName: this.childNode.name,
                pName:this.childNode.name+'企业数字化服务云平台',
              }
            })
          }
        })
      }
    }
  },
  mounted() {
    this.getPyfdAppOperatingIndustry();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
  }
}
</script>
<style scoped>
.development-container >>> .development-content .development-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #5D5D5D;
}

.development-container >>> .development-content .development-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.development-container >>> .development-content .development-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.development-container >>> .development-content .development-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.development-container >>> .development-content .development-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}

.development-container >>> .development-content .development-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}

.development-container >>> .development-content .development-breadcrumb .el-breadcrumb__inner a,
.development-container >>> .development-content .development-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #333333;
}
.development-container >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 73px;
  height: 73px;
}
.development-container >>> .el-upload--picture-card {
  width: auto;
  height: auto;
  line-height: normal;
  border: none;
  padding: 5px 10px 5px 0px;
  color: #1637FF;
}
.development-container >>> .development-content .development-info .developmentForm .el-upload--picture-card i {
  font-size: 14px;
  color: #1637FF;
}
.development-container >>> .development-content .development-info .developmentForm .el-link [class*=el-icon-]+span {
  margin-left: 0px;
}
.development-container >>> .development-content .development-info .developmentForm .el-link.el-link--primary {
  color: #1637FF;
  font-size: 14px;
}
.development-container >>> .development-content .development-info .developmentForm .el-button--primary {
  color: #FFF;
  background-color: #1637FF;
  border-color: #1637FF;
  padding: 10px 55px;
  font-size: 18px;
  font-family: 'SourceHanSansCN';
}
</style>
<style scoped lang="scss">
.development-container {
  background: #F2F3FB;

  .development-content {
    .development-breadcrumb {
      display: flex;
      justify-content: left;
      font-size: 14px;
      font-weight: 100;
      color: #333333;
      font-family: "SourceHanSansCN";
      padding: 10px 18%;
      min-width: 76rem;
      background: #F2F3FB;
    }

    .development-info {
      background: #ffffff;
      padding: 30px 18%;
      min-width: 76rem;
      .development-title {
        font-size: 24px;
        font-family: 'SourceHanSansCN';
        color: #333333;
        margin-block-start: 0px;
        cursor: pointer;
      }

      .development-tips {
        color: #999999;
        font-size: 16px;
        font-family: "SourceHanSansCN";
        line-height: 30px;
        cursor: pointer;
        margin-block-end: 30px;
      }

      .developmentForm {
        width: 80%;
      }
    }
  }
}
</style>